
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
              <v-col cols="3">
                  <v-text-field
                  label="Turno"
                  v-model="form.filters.turno"
                  outlined
                  dense
                  ></v-text-field>
              </v-col>
              <v-col cols="3">
              <v-text-field
                label="Hora de Início"
                v-model="form.filters.horaInicio"
                outlined
                dense
                v-mask="'##:##'"
                @keyup.enter="buscarRelatorios"
                :rules="[(h) => $horaValida(h)]"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Hora de Término"
                v-model="form.filters.horaFim"
                outlined
                dense
                v-mask="'##:##'"
                @keyup.enter="buscarRelatorios"
                :rules="[(h) => $horaValida(h)]"
              ></v-text-field>
            </v-col>
              <sca-select-ativo
                :cols="2"
                :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
                v-model="form.filters.situacao"
              ></sca-select-ativo>
          </v-row>
          <v-row class="d-flex justify-center mt-3">
            <sca-date-picker
              :cols="2"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
            <sca-date-picker
            :cols="2"
              v-model="form.filters.dataFim"
              label="Data Final"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
          </v-row>
           <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headersAnalitico"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        sort-by="dataHora"
        :sort-desc="true"
        item-key="id"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.horaInicioStr`]="{ item }">
          {{ item.horaInicioStr }}
        </template>
        <template v-slot:[`item.horaTerminoStr`]="{ item }">
          {{ item.horaTerminoStr }}
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.situacao" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataHora`]="{ item }">
          {{ item.dataHora }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorioPdf"
        @cancel="baixarCSVRelatorio"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLog from "services/relatorios-log/manter-turno-log.service"
  export default {
      name: "RelatorioLogTurno",
      mixins: [pageLoadingMixin, RelatorioDeLog],

      data: () => ({
      onReport: false,
      expanded: [],
      form: {
          filters: {
              turno: null,
              horaInicio: null,
              horaFim: null,
              situacao: null,
              dataInicio: null,
              dataFim: null,
          },
          lists: {
              listRelatorios: [],
          },
      },
      headersAnalitico: [
          { text: "Turno", align: "center", value: "nome" },
          { text: "Hora de Início", align: "center", value: "horaInicioStr" },
          { text: "Hora de Término", align: "center", value: "horaTerminoStr" },
          { text: "Situação", align: "center", value: "situacao" },
          { text: "Data/Hora da ação", align: "center", value: "dataHora" },
          { text: "Ação", align: "center", value: "acao" },
      ],
      }),
      methods: {
      async buscarRelatorios() {
          const horaInicioValida = this.$horaValida(this.form.filters.horaInicio) === true;
          const horaFimValida = this.$horaValida(this.form.filters.horaFim) === true;

          if (!horaInicioValida || !horaFimValida) {
            this.$notifyError('Hora inválida!');
            return;
          }
          const isValid = this.validarDatas();
          if (!isValid) return;
          if (!this.verificarFiltrosPreenchidos()) return;
          const filtros = { ...this.form.filters };
          if (filtros.horaInicio) {
            filtros.horaInicio = `${filtros.horaInicio}:00`;
          }
          if (filtros.horaFim) {
            filtros.horaFim = `${filtros.horaFim}:00`;
          }
          this.showPageLoading();
          try {
          const { data } = await this.$obterRelatorioLogTurno({ params: filtros });
          this.processarRespostaRelatorio(data);
          } finally {
          this.hidePageLoading();
          }
      },
      validarDatas() {
      const { dataInicio, dataFim } = this.form.filters;

      if (dataInicio && dataFim) {
        if (new Date(dataFim) < new Date(dataInicio)) {
          this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
          return false;
        }
        if (new Date(dataInicio) > new Date(dataFim)) {
          this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
          return false;
        }
      }
      return true;
    },

    verificarFiltrosPreenchidos() {
      const { turno, horaInicio, horaFim, situacao, dataInicio, dataFim } = this.form.filters;
      if (!turno && !horaInicio && !horaFim  && situacao == null && !dataInicio && !dataFim) {
        this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
        return false;
      }
      return true;
    },

      async baixarCSVRelatorio() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogCSVTurno({ params: this.form.filters });
        this.$baixarRelatorioCSV(data, `SCA.RelatórioDeLogDeTurnoCSV`);
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      async baixarRelatorioPdf() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogPDFTurno({ params: this.form.filters });
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SCA.RelatórioDeLogDeTurno.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      processarRespostaRelatorio(data) {
        this.form.lists.listRelatorios = data.relatorio.lista;
      },

      resetForm() {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFim = null;

        this.$nextTick(() => {
          this.$set(this.form.filters, 'dataInicio', null);
          this.$set(this.form.filters, 'dataFim', null);
        });
        this.form.filters.turno = null;
        this.form.filters.horaInicio = null;
        this.form.filters.horaFim = null;
        this.form.filters.situacao = null;
        this.form.lists.listRelatorios = [];
      },
    },
  };
</script>
